import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const admin_get_escrow_stats = createAsyncThunk(
    'escrow/admin_get_stats',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/escrow/stats', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_get_escrow_list = createAsyncThunk(
    'escrow/admin_get_list',
    async ({ status = 'all', page = 1, limit = 20 } = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/escrow?status=${status}&page=${page}&limit=${limit}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_release_escrow = createAsyncThunk(
    'escrow/admin_release',
    async ({ escrowId, note = '' }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/escrow/${escrowId}/release`, { note }, { withCredentials: true })
            return fulfillWithValue({ ...data, escrowId })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_refund_escrow = createAsyncThunk(
    'escrow/admin_refund',
    async ({ escrowId, note = '' }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/escrow/${escrowId}/refund`, { note }, { withCredentials: true })
            return fulfillWithValue({ ...data, escrowId })
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_get_escrow_settings = createAsyncThunk(
    'escrow/admin_get_settings',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/escrow/settings', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const admin_save_escrow_settings = createAsyncThunk(
    'escrow/admin_save_settings',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put('/admin/escrow/settings', payload, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

const escrowSlice = createSlice({
    name: 'escrow',
    initialState: {
        stats: null,
        escrows: [],
        totalEscrows: 0,
        settings: { escrow_auto_release_days: 7 },
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(admin_get_escrow_stats.fulfilled, (state, { payload }) => {
                state.stats = payload
            })
            .addCase(admin_get_escrow_list.fulfilled, (state, { payload }) => {
                state.escrows = payload.escrows
                state.totalEscrows = payload.total
            })
            .addCase(admin_release_escrow.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.escrows = state.escrows.map(e =>
                    e._id === payload.escrowId ? { ...e, status: 'released' } : e
                )
            })
            .addCase(admin_refund_escrow.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                state.escrows = state.escrows.map(e =>
                    e._id === payload.escrowId ? { ...e, status: 'refunded' } : e
                )
            })
            .addCase(admin_get_escrow_settings.fulfilled, (state, { payload }) => {
                state.settings = payload
            })
            .addCase(admin_save_escrow_settings.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addMatcher(
                (action) => action.type.startsWith('escrow/') && action.type.endsWith('/rejected'),
                (state, { payload }) => {
                    state.errorMessage = payload?.error || payload?.message || 'Something went wrong'
                }
            )
    }
})

export const { messageClear } = escrowSlice.actions
export default escrowSlice.reducer
